import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from '../../../dashboard.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/services/notification.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { DocumentGenerabil } from '../../../document.interface';
import { finalize, forkJoin } from 'rxjs';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { DocumentHeaderFooterService } from 'src/app/platform/nomenclatoare/document-header-footer/document-header-footer.service';
import { DocumentHeader, DocumentFooter } from 'src/app/platform/nomenclatoare/document-header-footer/document-header-footer.interface';

@Component({
    selector: 'app-edit-document-oficial',
    templateUrl: './edit-document-oficial.component.html',
    styleUrls: ['./edit-document-oficial.component.scss'],
})
export class EditDocumentOficialComponent implements OnInit {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    isLoading: boolean = false;

    destination = 'toPrimarie';

    // Header/Footer data
    availableHeaders: DocumentHeader[] = [];
    availableFooters: DocumentFooter[] = [];

    form: FormGroup = new FormGroup({
        // numar: new FormControl(this.data.numar, [Validators.required]),
        // data: new FormControl(this.data.data, [Validators.required]),
        content: new FormControl(this.data.content),
        content_citizen: new FormControl(this.data.content_citizen),
        // observatii: new FormControl(this.data.observations),
        template_id: new FormControl(this.data.template_id, [Validators.required]),
        valability: new FormControl(this.data.valability),
        use_header: new FormControl(this.data.use_header !== false),
        use_footer: new FormControl(this.data.use_footer !== false),
        header_id: new FormControl(this.data.header_id || null),
        footer_id: new FormControl(this.data.footer_id || null),
        // obiect_activitate: new FormControl('', [Validators.required]),
        // cerere_id: new FormControl(this.data.cerere_id, [Validators.required]),
        // subtype_id: new FormControl(this.data.subtype_id, [Validators.required]),
        // document_id: new FormControl(this.data.id_document, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: DocumentGenerabil,
        private docService: DashboardService,
        private dialogRef: MatDialogRef<EditDocumentOficialComponent>,
        private notificationService: NotificationService,
        public toastr: ToastrService,
        private headerFooterService: DocumentHeaderFooterService
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit(): void {
        this.loadHeadersAndFooters();
        console.log(this.data);
    }

    loadHeadersAndFooters(): void {
        forkJoin({
            headers: this.headerFooterService.getHeadersListActive(),
            footers: this.headerFooterService.getFootersListActive()
        }).subscribe({
            next: (response: any) => {
                this.availableHeaders = response.headers.data || [];
                this.availableFooters = response.footers.data || [];
            },
            error: (err) => {
                console.error('Error loading headers/footers:', err);
            }
        });
    }

    submitForm() {
        this.isLoading = true;

        const formValue = this.form.value;

        this.docService
            .updateDocument(this.data.id_document, formValue)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                },
            });
    }

    onHttpError(res: any, showErrorsInToast: boolean = false) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                if (showErrorsInToast) {
                    this.openToast({
                        title: this.errorTitle,
                        message: msg,
                        type: this.errorType,
                    });
                } else {
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                }
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }

    openToast(object: any) {
        const { type, message, title } = object;

        let options = this.toastr.toastrConfig;
        options.progressBar = true;
        options.preventDuplicates = true;
        options.closeButton = true;

        const inserted = this.toastr.show(
            message,
            title,
            options,
            options.iconClasses[type]
        );
    }

    onDestinatieChange(event: MatButtonToggleChange) {
        this.destination = event.value;
    }
}
